/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdpClaimMappingDto } from './IdpClaimMappingDto';
import {
    IdpClaimMappingDtoFromJSON,
    IdpClaimMappingDtoFromJSONTyped,
    IdpClaimMappingDtoToJSON,
    IdpClaimMappingDtoToJSONTyped,
} from './IdpClaimMappingDto';

/**
 * Draft IdP claim mapping rules to validate for a domain mapping
 * @export
 * @interface DomainMappingIdpClaimMappingValidateRequest
 */
export interface DomainMappingIdpClaimMappingValidateRequest {
    /**
     * 
     * @type {string}
     * @memberof DomainMappingIdpClaimMappingValidateRequest
     */
    tenantId?: string;
    /**
     * 
     * @type {Array<IdpClaimMappingDto>}
     * @memberof DomainMappingIdpClaimMappingValidateRequest
     */
    idpClaimMappings?: Array<IdpClaimMappingDto>;
}

/**
 * Check if a given object implements the DomainMappingIdpClaimMappingValidateRequest interface.
 */
export function instanceOfDomainMappingIdpClaimMappingValidateRequest(value: object): value is DomainMappingIdpClaimMappingValidateRequest {
    return true;
}

export function DomainMappingIdpClaimMappingValidateRequestFromJSON(json: any): DomainMappingIdpClaimMappingValidateRequest {
    return DomainMappingIdpClaimMappingValidateRequestFromJSONTyped(json, false);
}

export function DomainMappingIdpClaimMappingValidateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainMappingIdpClaimMappingValidateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'idpClaimMappings': json['idpClaimMappings'] == null ? undefined : ((json['idpClaimMappings'] as Array<any>).map(IdpClaimMappingDtoFromJSON)),
    };
}

export function DomainMappingIdpClaimMappingValidateRequestToJSON(json: any): DomainMappingIdpClaimMappingValidateRequest {
    return DomainMappingIdpClaimMappingValidateRequestToJSONTyped(json, false);
}

export function DomainMappingIdpClaimMappingValidateRequestToJSONTyped(value?: DomainMappingIdpClaimMappingValidateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'idpClaimMappings': value['idpClaimMappings'] == null ? undefined : ((value['idpClaimMappings'] as Array<any>).map(IdpClaimMappingDtoToJSON)),
    };
}

